/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('PrSkillCtrl', ["$scope", "$rootScope", "$dialog", "$timeout", "DateSrv", "PhysicalResourceSrv", "PhysicalResourceData", "CategoryData", "CategoryView", "gettextCatalog", function ($scope, $rootScope, $dialog, $timeout, DateSrv, PhysicalResourceSrv, PhysicalResourceData, CategoryData, CategoryView, gettextCatalog) {

    $scope.$watch('dd.displaySubConf', function (newValue, oldValue) {
        if (newValue == 2) {
            //INIT VIEW
            $scope.loadSkillView();
        }
    });

    $scope.loadSkillView = function () {
        //$timeout(function () {//In order to reduce wa
        var categoryRootView = new CategoryView(CategoryData.categoryRoot, CategoryData.getIndexOf(CategoryData.categoryRoot), null, $scope);// categoryRoot index  = 0
        $scope.dd.skillRoot = {
            type: "Category",
            label: gettextCatalog.getString("Toutes les prestations"),
            show: true,
            open: true,
            element: categoryRootView,
            subElement: [],
            level: 0,
            shift: 0,
            physicalResourceValues: []
        };
        $scope.dd.skills = [];
        $scope.dd.skills.push($scope.dd.skillRoot);
        $scope.dd.view.physicalResourcesView = [];
        for (var i = 0; i < $scope.dd.view.physicalResourcesActiveView.length; i++) {
            if ($scope.dd.view.physicalResourcesActiveView[i].hasPlanning)
                $scope.dd.view.physicalResourcesView.push($scope.dd.view.physicalResourcesActiveView[i]);   // planning actived
        }
        $scope.fillSkills($scope.dd.skillRoot);
        $scope.dd.loading = false;
        //},50);
    };
    $scope.fillSkills = function (skillCategory) {
        var prViews = $scope.dd.view.physicalResourcesView;

        for (var i = 0; i < prViews.length; i++)
            skillCategory.physicalResourceValues.push("on");

        var prOneSonTrueValues = [];
        for (i = 0; i < prViews.length; i++)
            prOneSonTrueValues.push(false);

        for (i = 0; i < skillCategory.element.categoriesView.length; i++) {
            var newSkillCategory = {
                type: "Category",
                label: skillCategory.element.categoriesView[i].label,
                show: skillCategory.open,
                open: false,
                element: skillCategory.element.categoriesView[i],
                subElement: [],
                level: skillCategory.level + 1,
                shift: 0,
                physicalResourceValues: []
            };
            skillCategory.subElement.push(newSkillCategory);
            $scope.dd.skills.push(newSkillCategory);
            var physicalResourceValuesCat = $scope.fillSkills(newSkillCategory);
            for (var k = 0; k < prViews.length; k++)
                if (physicalResourceValuesCat[k] == "on")
                    prOneSonTrueValues[k] = true;
                else if (skillCategory.physicalResourceValues[k] == "on") //if partial set dont change it
                    skillCategory.physicalResourceValues[k] = physicalResourceValuesCat[k];
        }
        for (i = 0; i < skillCategory.element.servicesView.length; i++) {
            var newSkillService = {
                type: "Service",
                label: skillCategory.element.servicesView[i].label,
                show: skillCategory.open,
                element: skillCategory.element.servicesView[i],
                level: skillCategory.level + 1,
                shift: 1,
                physicalResourceValues: []
            };

            for (var j = 0; j < prViews.length; j++)
                if (prViews[j].getModel() && prViews[j].getModel().hasService(skillCategory.element.servicesView[i].getModel())) {
                    newSkillService.physicalResourceValues.push("on");
                    prOneSonTrueValues[j] = true;
                } else {
                    newSkillService.physicalResourceValues.push("off");
                    skillCategory.physicalResourceValues[j] = "off";
                }
            skillCategory.subElement.push(newSkillService);
            $scope.dd.skills.push(newSkillService);
        }
        for (i = 0; i < prViews.length; i++) {
            if (skillCategory.physicalResourceValues[i] == "off" && prOneSonTrueValues[i])
                skillCategory.physicalResourceValues[i] = "partial";
        }

        return skillCategory.physicalResourceValues;
    };
    $scope.skillClick = function (skill, prIndex) {
        //se
        var changed = false;
        if (skill.physicalResourceValues[prIndex] == "on")
            changed = $scope.updateSubElementPrValues(skill, prIndex, "off");
        else
            changed = $scope.updateSubElementPrValues(skill, prIndex, "on");
        $scope.updateCategoryPrValues($scope.dd.skillRoot, prIndex);

        if (changed)
            PhysicalResourceSrv.save($scope.dd.view.physicalResourcesView[prIndex].getModel());
    };
    $scope.updateSubElementPrValues = function (skill, prIndex, value) {
        var changed = false;
        if (skill.physicalResourceValues[prIndex] != value) {
            skill.physicalResourceValues[prIndex] = value;
            if (skill.type == "Service")//Save it
            {
                if (skill.physicalResourceValues[prIndex] == "on")
                    $scope.dd.view.physicalResourcesView[prIndex].getModel().addService(skill.element.getModel());
                else
                    $scope.dd.view.physicalResourcesView[prIndex].getModel().removeService(skill.element.getModel());

                changed = true;
            }
        }

        if (skill.subElement)
            for (var j = 0; j < skill.subElement.length; j++)
                changed = $scope.updateSubElementPrValues(skill.subElement[j], prIndex, value) || changed;

        return changed

    };
    $scope.updateCategoryPrValues = function (skillCategory, prIndex) {
        var prValue = "on";
        var cprValue = "on";
        var prOneSonTrueValue = false;
        for (var j = 0; j < skillCategory.subElement.length; j++) {
            if (skillCategory.subElement[j].type == "Category") {
                cprValue = $scope.updateCategoryPrValues(skillCategory.subElement[j], prIndex);
                if (cprValue == "on")
                    prOneSonTrueValue = true;
                else////cprValue = partial or off
                if (prValue == "on") //if partial set dont change it
                    prValue = cprValue;
            } else {
                if (skillCategory.subElement[j].physicalResourceValues[prIndex] == "off")
                    prValue = "off";
                else
                    prOneSonTrueValue = true;
            }
        }
        if (prValue == "off" && prOneSonTrueValue)
            prValue = "partial";
        skillCategory.physicalResourceValues[prIndex] = prValue;
        return prValue;

    };
    $scope.openSkillCategory = function (skillCategory) {
        skillCategory.open = true;
        for (var j = 0; j < skillCategory.subElement.length; j++)
            $scope.propagateShowStatus(skillCategory.subElement[j], true);
    };
    $scope.closeSkillCategory = function (skillCategory) {
        skillCategory.open = false;
        for (var j = 0; j < skillCategory.subElement.length; j++) {
            $scope.propagateShowStatus(skillCategory.subElement[j], false);
        }
    };
    $scope.propagateShowStatus = function (skillCategory, showStatus) {
        skillCategory.show = showStatus;
        if (skillCategory.open && skillCategory.subElement)
            for (var j = 0; j < skillCategory.subElement.length; j++)
                $scope.propagateShowStatus(skillCategory.subElement[j], showStatus);
    };
}]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/pr/prSkillCtrl.js